import React from 'react'

const SixChatsOption = () => {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect className='custom-icon-stroke' x="3.84747" y="3.05158" width="4.47458" height="7.72881" rx="1.01695" stroke="white" strokeWidth="1.22034"/>
        <rect className='custom-icon-stroke' x="10.7625" y="3.05158" width="4.47458" height="7.72881" rx="1.01695" stroke="white" strokeWidth="1.22034"/>
        <rect className='custom-icon-stroke' x="17.6776" y="3.05158" width="4.47458" height="7.72881" rx="1.01695" stroke="white" strokeWidth="1.22034"/>
        <rect className='custom-icon-stroke' x="3.84747" y="13.2195" width="4.47458" height="7.72881" rx="1.01695" stroke="white" strokeWidth="1.22034"/>
        <rect className='custom-icon-stroke' x="10.7625" y="13.2195" width="4.47458" height="7.72881" rx="1.01695" stroke="white" strokeWidth="1.22034"/>
        <rect className='custom-icon-stroke' x="17.6776" y="13.2195" width="4.47458" height="7.72881" rx="1.01695" stroke="white" strokeWidth="1.22034"/>
    </svg>
  )
}

export default SixChatsOption
